import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import MainLayout from 'layouts/MainLayout'
import SecurityPage from 'components/PageComponents/Account/Security'

const AccountSecurityPage = () => (
  <>
    <Helmet>
      <title>Skefto: Security Settings</title>
    </Helmet>
    <MainLayout>
      <SecurityPage />
    </MainLayout>
  </>
)

export default AccountSecurityPage
